import React from "react";
import {Badge, CardBody, CardText, CardTitle} from "reactstrap";
import Gravatar from "react-gravatar";
import {FaCalendar, FaEnvelope, FaUserCircle} from "react-icons/fa";

const UserCard = ({data}) => {
  const {
    first_name = "",
    last_name = "",
    email = "",
    username = "",
    date_joined = "",
    is_active = false,
  } = data;

  let name = `${first_name} ${last_name}`;

  return (
    <CardBody style={{display: "flex", alignItems: "center", padding: "0px 10px"}}>
      <Gravatar
        email={email}
        size={300}
        rating="pg"
        default="identicon"
        className="avatar avatar-lg"
      />
      <div style={{flex: "1 1 auto", marginLeft: "10px"}}>
        <CardTitle tag="h3">
          <FaUserCircle aria-hidden="true" /> {name !== " " ? name : username}{" "}
          <Badge color="" className="badge-dot mr-4">
            {is_active ? <i className="bg-success" /> : <i className="bg-warning" />}
          </Badge>
        </CardTitle>
        <CardText style={{display: "flex", alignItems: "baseline"}}>
          <FaEnvelope aria-hidden="true" />
          <span
            className="user__email"
            style={{
              marginLeft: "5px",
            }}
          >
            {email}
          </span>
        </CardText>
        <CardText>
          <small>
            <FaCalendar /> Joined {date_joined}
          </small>
        </CardText>
      </div>
    </CardBody>
  );
};

export default UserCard;
